<template>
    <div>
        <div class="ibox float-e-margins  fadeInRight" v-if="intervals && Object.keys(intervals).length > 0">
            <div class="ibox-title select-services-dropdown-title">
                <b> Suggested Availability</b>
                <span class="float-r">
                     <div class="btn-group ">
                         <a type="button" class="btn btn-custom-suggestions new-design float-left btn-mobile-width"
                            v-if="isManuallyJobAssignment" href="#" data-target="#popupi" data-toggle="modal"
                            @click="SendToCustomer(itemId, suggestedAvailabilityTemplateName, customerId)"> Send email to customer</a>

                    </div>
                </span>
            </div>
            <div class="ibox-content p-all-5 time_suggestions">
                <div class="col-md-12 col-xs-12">
                    <div class="row suggested-style">
                        <div class="col-md-3 col-xs-4 no-padding">{{workersNameSingular}}</div>
                        <div class="col-md-3 col-xs-3 no-padding">Earliest available time</div>
                        <div class="col-md-3 col-xs-3 no-padding">Latest available time</div>
                        <div class="col-md-3 col-xs-2 no-padding"></div>
                    </div>
                    <div class="row suggested-style-another"  v-for="(intervalse , key) of intervals">
                        <div v-for="(interval , index) of intervalse" class="inline-custome col-xs-12">
                            <div class="col-md-3 col-xs-4 no-padding-another" v-if="index == 0">
                                <span class="gray-text span-font-size dropdown"
                                      @mouseover="handleMouseHover"
                                      @mouseleave="handleMouseLeave">
                                     <a style="text-decoration: none; color: #2E4051; text-transform: capitalize; font-weight: 700;" class="fieldworker-popover  dropdown-toggle"
                                        data-toggle="dropdown" aria-haspopup="true"
                                        href="javascript:void(0)"
                                        :data-contractor_id="interval.fieldworker_id"
                                        :data-uid="`vue_contractor-${interval.fieldworker_id}`"
                                        :data-item_id="itemId"
                                        :data-item_type="itemType">
                                         {{key}}
                                       <span class="caret"></span>
                                      </a>
                                      <div class="dropdown-menu mobile-view-transform" v-show="isDropdownVisible">
                                          <contractor-info :id="interval.fieldworker_id" :item-type="itemType" :item-id="itemId"></contractor-info>
                                      </div>

                                </span>

                            </div>
                            <div class="col-md-3 col-xs-4 no-padding-another" v-else>&nbsp;	</div>
                            <div class="col-md-3 col-xs-3 no-padding-another">{{interval.from}} &nbsp;</div>
                            <div class="col-md-3 col-xs-3 no-padding-another">{{interval.to}} &nbsp;</div>
                            <div class="col-md-3 col-xs-2 no-padding-another">
                                <a class="btn btn-custom-sm btn-custom-suggestions" @click="setSuggestedAvailability(itemId, interval.end_date, interval.start_time, interval.start_date, interval.fieldworker_id, key)">
                                    <i class="fa fa-calendar"></i> Apply
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal fade modalSuggestedAvailability" tabindex="7" role="dialog"  aria-hidden="true">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                            <h4 class="modal-title" >Set Availability For a Field Worker</h4>
                        </div>
                        <div class="modal-body" id="timebar-availability-form"  ref="timebarAvailabilityForm">
                        </div>
                        <div class="availability-modal-footer" id="timebar-availability-footer">
                            <a class="btn octopus-btn-danger " data-dismiss="modal">Close</a>
                            <a class="btn octopus-btn-default add-availability-submit" @click="confirmSuggestedAvailability"> Confirm </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import {getSuggestedAvailability, syncSuggestedAvailability} from "@/modules/SuggestedAvailability/api"
export default {
    name: "SuggestedAvailability",
    props: {
        workersNameSingular : null,
        intervals: null,
        itemId: null,
        itemType: null,
        customerId: null,
        isManuallyJobAssignment: null,
        suggestedAvailabilityTemplateName: null,
    },
    data() {
        return {
            isPopoverVisible: false,
            isDropdownVisible: false,
            dropDownClicked:0,
        };
    },
    methods: {
        SendToCustomer(itemId = 0, suggestedAvailabilityTemplateName, customerId) {
            // invoice/change-invoice/
            window.popupi('Send Email', `/get-canned-responses-form/customer/email/booking/${itemId}/${customerId}/${suggestedAvailabilityTemplateName}`)
        },
        setSuggestedAvailability(itemId, dataEndDate, startTime, startDate, fieldworkerId, username){
            getSuggestedAvailability(itemId, dataEndDate, startTime, startDate, fieldworkerId, username).then(response => {
                 $("#timebar-availability-form").html(response.data);
                 $(".modalSuggestedAvailability").find("input[name='from']").val(startTime);
                 $(".modalSuggestedAvailability").modal('show');
            })
        },
        confirmSuggestedAvailability() {
            // Use $nextTick to ensure the form has been rendered
            this.$nextTick(() => {
                // Accessing data from the form using the ref directly
                const formElement = this.$refs.timebarAvailabilityForm;

                if (formElement) {
                    // Extracting values from the form
                    const bookingId = formElement.querySelector('input[name="booking_id"]').value;
                    const contractorId = formElement.querySelector('input[name="contractor_id"]').value;
                    const visits = 0;
                    const fromDate = formElement.querySelector('input[name="from_date"]').value;
                    const fromTime = formElement.querySelector('input[name="from"]').value;
                    const toDate = formElement.querySelector('input[name="to_date"]').value;
                    const toTime = formElement.querySelector('input[name="to"]').value;


                    // Create your FormData object or use the values as needed
                    const formData = new FormData();
                    formData.append('booking_id', bookingId);
                    formData.append('contractor_id', contractorId);
                    formData.append('visit_id', visits);
                    formData.append('from_date', fromDate);
                    formData.append('from', fromTime);
                    formData.append('to_date', toDate);
                    formData.append('to', toTime);

                    // Do something with formData
                    syncSuggestedAvailability(formData).then(response => {
                        $(".modalSuggestedAvailability").modal('hide');
                        $.notify('Appointment has been scheduled.', 'success');
                        $('#fn_nearest').modal('show');
                        window.fn_popupi_with_parm('Notify Customer', `/booking/notify-customer/?booking_id=${bookingId}`,'notify_customer=["rescheduled"]');
                    })
                    // ... your existing logic ...
                } else {
                    $.notify('Error Form Data empty.', 'error');

                }

            });
        },
        handleMouseHover(e){
            this.isDropdownVisible = true
            if (this.dropDownClicked < 1){
                const targetElement = e.target;
                targetElement.click();
            }
            this.dropDownClicked += 1

        },
        handleMouseLeave(){
            this.isDropdownVisible = false
        }
    },
}
</script>

<style scoped>
.suggested-style{
    background-color: #d9edf7;
    padding: 10px;
}
.suggested-style-another{
    background-color: #fff;
    padding: 10px;
}
.no-padding{
    padding: 0px;
    font-weight: 700;
}
.no-padding-another{
    padding: 0px;
    font-weight: 600;
}
.inline-custome{
    margin-bottom: 50px;
    padding: 0px;
}
.btn-custom-suggestions{
    background: #2f4050 !important;
    border-color: #2f4050 !important;
    color: #fff !important;
}
.mobile-view-transform{
    min-width: 290px;
}
@media only screen and (max-width: 768px) {
    .mobile-view-transform {
        transform: translateX(0%);
    }

    .inline-custome{
        padding: 0px;
    }

    .btn-custom-sm{
        padding: 5px 10px;
        font-size: 12px;
        line-height: 1.5;
        border-radius: 3px;
    }
}

.btn-custom-suggestions:hover{
    color: #fff  !important;
    background-color: #286090  !important;
    border-color: #204d74  !important;
}
</style>